webpackJsonp([140525810354349],{

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coverage.0eb498eb.png";

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2013.dec4d434.png";

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2014.19c93be9.png";

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2015.480efc68.png";

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2016.6e9bd4d7.png";

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/costs-2017.25961513.png";

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2013.9197d6cf.png";

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2014.3091b450.png";

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2015.9c78bc78.png";

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2016.96d2e115.png";

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uninsured-2017.b13c49d1.png";

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "#4abdbc",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M388.214 5l-8.228 2.058-4.497 14.404-17.88 9.663-15.32-.551-8.779-10.314-9.94-4.848-6.474.873-6.144 6.56-17.411 57.938-3.114 71.429 7.33 41.253-.988 3.606-8.886 14.248-.108 6.107 3.995 6.264.082 2.724-9.496-.864-1.26.93 2.001 7.696-13.219-2.017-8.878 6.544 26.273 82.508 23.983 84.187 14.158 11.004 1.664 8.133L334.3 430l14.19-19.64 11.614-32.166-.412-13.968 6.094-11.77 8.582-7.507 4.613-.033 6.317 7.762 2.503.247 2.496-6.198-.033-12.256 2.71-1.342 4.842 4.774 3.072-.848 4.794-3.473 1.927-9.72 3.542-5.59 8.565.667 2.117-1.836 2.784-12.107-1.516-8.487 2.232-9.218-.93-12.627 4.53-6.486 3.648-2.584 2.47.214 3.163 8 4.407 5.499 5.987.115 5.172-4.223 13.433 5.35 4.514-3.456 1.606-6.635 6.564-9.91 5.666-1.662 6.285-5.548 1.367-8.083 17.666-8.65 3.072-5.853 7.824-3.26 2.792-4.543 9.027-3.638 5.403-7.515-.05-5.869-3.319-5.128-7.66.774-.263-3.004 2.06-7.713-8.088-17.894.033 3.687-4.942 2.412-10.798 1.12-11.456-3.359-4.884-4.675-8.763-23.516-19.322-3.177-35.72-120.922zM138.8 170l-5.736 4.554-22.342 8.273-5.582 9.652-4.173 34.011 6.043 10.794-8.387 26.323 15.77 21.783-1.299 12.187-21.923 33.287-18.267 11.211 5.163 53.844L61 469.081l12.183 84.136-4.982 24.43L83.677 595l131.387-32.549 36.437-34.693 11.485-.933.014-33.134-12.239-9.262-2.819-13.733-23.988-18.635L183.33 309.61z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 600 600"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Exhibit5Module = __webpack_require__(845);
	
	var _Exhibit5Module2 = _interopRequireDefault(_Exhibit5Module);
	
	var _costs = __webpack_require__(1388);
	
	var _costs2 = _interopRequireDefault(_costs);
	
	var _costs3 = __webpack_require__(1389);
	
	var _costs4 = _interopRequireDefault(_costs3);
	
	var _costs5 = __webpack_require__(1390);
	
	var _costs6 = _interopRequireDefault(_costs5);
	
	var _costs7 = __webpack_require__(1391);
	
	var _costs8 = _interopRequireDefault(_costs7);
	
	var _costs9 = __webpack_require__(1392);
	
	var _costs10 = _interopRequireDefault(_costs9);
	
	var _uninsured = __webpack_require__(1393);
	
	var _uninsured2 = _interopRequireDefault(_uninsured);
	
	var _uninsured3 = __webpack_require__(1394);
	
	var _uninsured4 = _interopRequireDefault(_uninsured3);
	
	var _uninsured5 = __webpack_require__(1395);
	
	var _uninsured6 = _interopRequireDefault(_uninsured5);
	
	var _uninsured7 = __webpack_require__(1396);
	
	var _uninsured8 = _interopRequireDefault(_uninsured7);
	
	var _uninsured9 = __webpack_require__(1397);
	
	var _uninsured10 = _interopRequireDefault(_uninsured9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  Styles
	
	
	//  Images
	
	
	var costImages = {
	  "2013": _costs2.default,
	  "2014": _costs4.default,
	  "2015": _costs6.default,
	  "2016": _costs8.default,
	  "2017": _costs10.default
	};
	
	var uninsuredImages = {
	  "2013": _uninsured2.default,
	  "2014": _uninsured4.default,
	  "2015": _uninsured6.default,
	  "2016": _uninsured8.default,
	  "2017": _uninsured10.default
	};
	
	var years = ["2013", "2014", "2015", "2016", "2017"];
	
	var Exhibit5 = function (_React$Component) {
	  _inherits(Exhibit5, _React$Component);
	
	  function Exhibit5() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Exhibit5);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { currentYear: "2013" }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Exhibit5.prototype.handleClick = function handleClick(year, e) {
	    this.setState({ currentYear: year });
	    e.preventDefault();
	  };
	
	  Exhibit5.prototype.render = function render() {
	    var _this2 = this;
	
	    var currentYear = this.state.currentYear;
	
	
	    return _react2.default.createElement(
	      'figure',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'title__block' },
	        'Cost barriers to receiving care fell as uninsured rates fell following ACA coverage expansions'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'instructions' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Select a year to see changes over time.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: _Exhibit5Module2.default.year__nav },
	        _react2.default.createElement(
	          'ul',
	          { className: [_Exhibit5Module2.default.year__list, _Exhibit5Module2.default['year__list__' + currentYear]].join(" ") },
	          years.map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              { key: year, className: [currentYear === year ? _Exhibit5Module2.default.year__list__item__active : "", _Exhibit5Module2.default.year__list__item].join(" ") },
	              _react2.default.createElement(
	                'a',
	                { href: '#year_' + year, 'aria-controls': '#year_' + year, onClick: function onClick(e) {
	                    return _this2.handleClick(year, e);
	                  } },
	                year
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Exhibit5Module2.default.images },
	        _react2.default.createElement(
	          'ul',
	          { className: _Exhibit5Module2.default.image__list },
	          years.map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              { key: year, id: 'year_' + year, className: _Exhibit5Module2.default.image__list__year, 'aria-hidden': currentYear === year ? false : true },
	              _react2.default.createElement(
	                'div',
	                { className: [_Exhibit5Module2.default.map, _Exhibit5Module2.default.map__cost].join(" ") },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Uninsured adults'
	                ),
	                _react2.default.createElement(
	                  'figure',
	                  null,
	                  _react2.default.createElement('img', { src: uninsuredImages[year], alt: '' }),
	                  _react2.default.createElement(
	                    'figcaption',
	                    null,
	                    year
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: [_Exhibit5Module2.default.map, _Exhibit5Module2.default.map__uninsured].join(" ") },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Adults who went without care because of costs'
	                ),
	                _react2.default.createElement(
	                  'figure',
	                  null,
	                  _react2.default.createElement('img', { src: costImages[year], alt: '' }),
	                  _react2.default.createElement(
	                    'figcaption',
	                    null,
	                    year
	                  )
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _Exhibit5Module2.default.legend },
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit5Module2.default.legend__light },
	            'Less than 10%'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit5Module2.default.legend__medium },
	            '10%-14%'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Exhibit5Module2.default.legend__dark },
	            '15% or more'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'figcaption',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Notes: Adults who went without care is limited to adults ages 18\u201364 in this exhibit, though the Scorecard ranks states on a version of this measure that includes all adults age 18 and older.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Data: Uninsured (ages 19\u201364): U.S. Census Bureau, 2013\u20132017 One-Year American Community Surveys, Public Use Micro Sample (ACS PUMS); Cost barriers (ages 18\u201364): 2013\u20132017 Behavioral Risk Factor Surveillance System (BRFSS).'
	        )
	      )
	    );
	  };
	
	  return Exhibit5;
	}(_react2.default.Component);
	
	exports.default = Exhibit5;
	module.exports = exports['default'];

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"year__nav":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__nav---1pAbb","year__list":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list---so96n","year__list__2014":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__2014---2Z8GO","year__list__2015":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__2015---nM0tb","year__list__2016":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__2016---3Vo8G","year__list__2017":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__2017---1JKun","year__list__item":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__item---2Bu-b","year__list__item__active":"src-components-Exhibits-Exhibit5----Exhibit5-module---year__list__item__active---2ffqZ","image__list":"src-components-Exhibits-Exhibit5----Exhibit5-module---image__list---2nBPL","image__list__year":"src-components-Exhibits-Exhibit5----Exhibit5-module---image__list__year---31_-P","map":"src-components-Exhibits-Exhibit5----Exhibit5-module---map---1D4u1","legend":"src-components-Exhibits-Exhibit5----Exhibit5-module---legend---2AS5A","legend__light":"src-components-Exhibits-Exhibit5----Exhibit5-module---legend__light---1yZfQ","legend__medium":"src-components-Exhibits-Exhibit5----Exhibit5-module---legend__medium---2S-by","legend__dark":"src-components-Exhibits-Exhibit5----Exhibit5-module---legend__dark---6qWdp"};

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(64);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(103);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Exhibit = __webpack_require__(546);
	
	var _Exhibit2 = _interopRequireDefault(_Exhibit);
	
	var _Button = __webpack_require__(36);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _caseStudyTwoStates = __webpack_require__(184);
	
	var _caseStudyTwoStates2 = _interopRequireDefault(_caseStudyTwoStates);
	
	var _coverage = __webpack_require__(1385);
	
	var _coverage2 = _interopRequireDefault(_coverage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Theme2Page = function Theme2Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[1].node,
	        img: _coverage2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__summary' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The ',
	            _react2.default.createElement(
	              'em',
	              null,
	              '2019 State Scorecard'
	            ),
	            ' found that the historic gains made by states in expanding health insurance coverage and access to care following the Affordable Care Act\u2019s major coverage expansions in 2014 have stalled or even begun to erode in some states.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'States\u2019 historic progress in expanding health insurance coverage and access to care has stalled'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'In nearly all states, there were widespread reductions in uninsured rates between 2013 and 2017, in the wake of the ACA\u2019s insurance market reforms and coverage expansions (',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/coverage/#exhibit-5' },
	                'Exhibit 5'
	              ),
	              ', ',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C2'
	              ),
	              ').'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'As more people gained coverage, fewer cited cost as a barrier to receiving needed care. But in most states, progress stalled after 2015. From 2016 to 2017, more than half of states simply held on to earlier gains; 16 states, including those that did and did not expand Medicaid, experienced upticks of 1 percentage point in their adult uninsured rate (',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C3'
	              ),
	              ').',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#7' },
	                  '7'
	                )
	              ),
	              ' One notable exception was Louisiana, where Medicaid expansion took effect in July 2016. Louisiana experienced a 3 percentage-point drop in its adult uninsured rate (from 15% to 12%) from the end of 2016 to the end of 2017. People with low income made the greatest gains (',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendices C3 and C4'
	              ),
	              ').'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-5', className: 'section__content section__exhibit section__exhibit__padded section__full section__exhibit__interactive' },
	          _react2.default.createElement(_Exhibit2.default, null),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-5',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Medicaid makes a difference in lowering uninsured rates'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'States\u2019 decisions about whether to expand their Medicaid programs have had stark implications for their uninsured rates.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is apparent in the sixfold variation across state uninsured rates in 2017, ranging from a low of 4 percent in Massachusetts (which expanded Medicaid along with coverage enhancements like extra subsidies) to a high of 24 percent in Texas (which did not expand) (',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/coverage/#exhibit-6' },
	                'Exhibit 6'
	              ),
	              ', ',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C2'
	              ),
	              '). Among the 17 states that have yet to expand Medicaid, five had the highest uninsured rates, ranging from 18 percent to 24 percent.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-6', className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Five of the 17 states that have yet to expand Medicaid had the highest adult uninsured rates in 2017'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-6-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: As of January 1, 2017, there were 19 states that had not expanded Medicaid. Maine and Virginia implemented Medicaid expansion in 2019; Idaho, Nebraska, and Utah passed ballot initiatives in November 2018 to expand Medicaid but have not yet implemented a full expansion; Utah made adults up to 100% of poverty eligible. Adults with incomes up to 100% of poverty are eligible for Medicaid in Wisconsin.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: U.S. Census Bureau, 2017 One-Year American Community Surveys. Public Use Micro Sample (ACS PUMS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-06',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'In states that recently expanded Medicaid, uninsured rates among low-income adults dropped substantially in 2017'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'All states saw reductions in uninsured rates among low-income adults following the ACA\u2019s 2014 coverage expansions, with states that expanded Medicaid seeing the largest drops. After falling through 2015, state uninsured rates among low-income adults did not change much between 2016 and 2017 (',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/coverage/#exhibit-7' },
	                'Exhibit 7'
	              ),
	              ').'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The notable exceptions to this trend were three states that expanded Medicaid in 2015 or later: Alaska (September 2015), Louisiana (July 2016), and Montana (January 2016). Uninsured rates among low-income adults in these states dropped by 8, 6, and 4 percentage points, respectively, from the end of 2016 to the end of 2017. These gains suggest the potential for improving uninsured rates among low-income adults in the latest batch of states that have either expanded Medicaid (Maine and Virginia in 2019) or are poised to (Idaho, Nebraska, and Utah passed ballot initiatives in November 2018 to expand the program). In contrast, the failure of a November ballot initiative in Montana to permanently reauthorize the state\u2019s full Medicaid expansion, which was due to \u201Csunset\u201D this summer, and subsequent legislation that would impose work requirements for enrollees, could endanger recent gains made there.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#8' },
	                  '8'
	                )
	              ),
	              ' In Wyoming, Montana\u2019s neighbor \u2014 which has not expanded its Medicaid program \u2014 a third of low-income adults were uninsured in 2017.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Uninsured rates among people of color are also high in several of the states that have yet to expand Medicaid and are home to large African American and Hispanic populations. In Florida, Georgia, and Texas, for example, about 20 percent of black adults were uninsured in 2017, above the U.S. average of 14 percent (',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C3'
	              ),
	              '). More than a third of Hispanic adults in Texas and close to half of Hispanic adults in Georgia were uninsured in 2017. By contrast, uninsured rates among Hispanic adults in New York and in California, two states that did expand Medicaid, were 16 percent and 17 percent, respectively.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#9' },
	                  '9'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-7', className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'States that more recently implemented Medicaid expansion saw the biggest drops in uninsured low-income adults in 2017'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-7-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Notes: Low-income adults defined as adults ages 19\u201364 living in a household with income <200% of the federal poverty level. Medicaid expansion states are those states that expanded Medicaid by January 1, 2017. States arranged in order of their 2017 rate.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: U.S. Census Bureau, 2017 1-Year American Community Survey, American FactFinder and 2016 1-Year American Community Surveys, Public Use Micro Sample (ACS PUMS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-7',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Cost barriers to care on the rise'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'As the progress in expanding health coverage stalled, so too did gains in people\u2019s ability to access health care. Between 2016 and 2017, a dozen states had increases of at least 2 percentage points in the share of adults ages 18 to 64 who reported they had not gone to the doctor when needed because of cost (',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/coverage/#exhibit-8' },
	                'Exhibit 8'
	              ),
	              ').',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#10' },
	                  '10'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'But it\u2019s also worth noting that as with uninsured rates among low-income adults, some states that expanded Medicaid after 2014 saw a decrease in the share of adults in this income group who skipped needed care because of cost between 2016 and 2017. In Alaska, for example, the rate of low-income adults who went without care because of cost dropped from 31 percent in 2016 to 13 percent in 2017; in Louisiana, the rate dropped from 37 percent to 28 percent (',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C4'
	              ),
	              ').'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-8', className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'The share of adults ages 18\u201364 who skipped needed care because of cost climbed by 2 percentage points or more in a dozen states between 2016 and 2017, eroding earlier gains'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-8-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: States are arranged in rank order based on their 2016 value. * Rate increase refers to change between 2016 and 2017 of at least 2 percentage points. Adults who went without care is limited to adults ages 18\u201364 in this exhibit, though the Scorecard ranks states on a version of this measure that includes all adults age 18 and older.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2016 and 2017 Behavioral Risk Factor Surveillance System (BRFSS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-8',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Can Be Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'In partnership with the federal government, states can expand access to health insurance and to high-quality health care by expanding Medicaid eligibility under the Affordable Care Act (17 states have yet to do so). They can also stabilize and strengthen individual insurance markets through reinsurance programs, which protect insurers against unexpectedly high claims.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '7', style: { counterReset: "item 6" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '7' },
	              'In its analysis of state uninsured rates among the total civilian noninstitutionalized population, the U.S. Census Bureau found statistically significant upticks of between 0.3 and 1 percentage point in 14 states between 2016 and 2017. Edward R. Berchick, Emily Hood, and Jessica C. Barnett, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.census.gov/content/dam/Census/library/publications/2018/demo/p60-264.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Health Insurance Coverage in the United States: 2017'
	                )
	              ),
	              ', Current Population Reports, P60-264 (U.S. Census Bureau, Sept. 2018).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '8' },
	              'Akeiisa Coleman, Rachel Nuzum, and Susan L. Hayes, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2019/medicaid-expansion-across-country-check-recent-ballot-initiatives' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Medicaid Expansion Across the Country: A Check-In on Recent Ballot Initiatives'
	                )
	              ),
	              ',\u201D To the Point (blog), Commonwealth Fund, Feb. 25, 2019; and Amy Beth Hanson, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.governing.com/topics/health-human-services/Medicaid-Expansion-Bill-Signed-by-Montana-Governor.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Medicaid Expansion Bill Signed by Montana Governor'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Governing'
	              ),
	              ', May 13, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '9' },
	              'See the Commonwealth Fund\u2019s online ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://datacenter.commonwealthfund.org' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Health System Data Center'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '10' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/coverage/#exhibit-7' },
	                'Exhibit 7'
	              ),
	              ' uses data that are limited to the working-age adult population ages 18\u201364, and these are the values discussed here and shown in ',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C4'
	              ),
	              '. Note that states are ranked on a version of this indicator that includes all adults age 18 and older. These rates can be found in ',
	              _react2.default.createElement(
	                'a',
	                { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2019_APPENDICES.pdf') },
	                'Appendix C2'
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Theme2Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-coverage-js-56544ab3c13b25f47e4a.js